export const CLASS_NAMES = {
  wrapper: {
    base: 'flex flex-col items-center justify-start h-screen py-5',
    '@background': {
      false: '',
      true: ' bg-neutral-100',
    },
  },
  innerWrapper: 'flex flex-col items-center justify-center max-w-120',
  card: 'bg-neutral-000 rounded-xl',
  logo: 'mx-auto mt-4 mb-6',
};
